var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "bbf_trashicon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4191 0.585786C6.79417 0.210714 7.30288 0 7.83331 0H11.8333C12.3637 0 12.8725 0.210714 13.2475 0.585786C13.6226 0.960859 13.8333 1.46957 13.8333 2V4H17.8333C18.3856 4 18.8333 4.44772 18.8333 5C18.8333 5.55228 18.3856 6 17.8333 6H17.7645L16.9638 17.213C16.9638 17.2131 16.9638 17.2129 16.9638 17.213C16.9099 17.9698 16.5712 18.6783 16.016 19.1954C15.4607 19.7125 14.7301 20 13.9713 20H5.69534C4.93655 20 4.20594 19.7125 3.65066 19.1954C3.09545 18.6783 2.75678 17.97 2.70285 17.2132C2.70285 17.2132 2.70286 17.2133 2.70285 17.2132L1.90217 6H1.83331C1.28103 6 0.833313 5.55228 0.833313 5C0.833313 4.44772 1.28103 4 1.83331 4H5.83331V2C5.83331 1.46957 6.04403 0.960859 6.4191 0.585786ZM7.83331 4H11.8333V2H7.83331V4ZM3.90726 6L4.69777 17.0708C4.71573 17.3231 4.82864 17.5594 5.01373 17.7318C5.19882 17.9042 5.44236 18 5.69531 18H13.9713C14.2243 18 14.4678 17.9042 14.6529 17.7318C14.838 17.5594 14.9509 17.3233 14.9688 17.071L15.7594 6H3.90726ZM7.83331 8C8.3856 8 8.83331 8.44772 8.83331 9V15C8.83331 15.5523 8.3856 16 7.83331 16C7.28103 16 6.83331 15.5523 6.83331 15V9C6.83331 8.44772 7.28103 8 7.83331 8ZM11.8333 8C12.3856 8 12.8333 8.44772 12.8333 9V15C12.8333 15.5523 12.3856 16 11.8333 16C11.281 16 10.8333 15.5523 10.8333 15V9C10.8333 8.44772 11.281 8 11.8333 8Z",
    fill: "#6363FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2a7b93725748d28d7dc441fb1c1ed590.svg";
export { ForwardRef as ReactComponent };